// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAuthenticate from 'vue-authenticate'
import VueBreadcrumbs from 'vue-breadcrumbs'
import Vddl from 'vddl'
import vSelect from 'vue-select'
import AphexModal from './components/Helpers/Modal/Form'
import PrettyCheckbox from 'pretty-checkbox-vue'
import VueSweetalert2 from 'vue-sweetalert2'
import FlagIcon from 'vue-flag-icon'
import papaparse from 'papaparse'
import InWrapper from './components/Helpers/Inspinia/Wrapper'
import InIbox from './components/Helpers/Inspinia/Ibox'
import OnOff from './components/Helpers/Form/OnOff'
import 'bootstrap/dist/js/bootstrap.js'
import 'bootstrap/dist/css/bootstrap.css'
import 'datatables'
import 'datatables.net-bs4/css/dataTables.bootstrap4.css'
import 'datatables.net-buttons'
import 'datatables.net-buttons-bs4'
import aDataTable from './components/Helpers/Table/aDataTable'

import 'icheck'

import './sass/style.scss'
import './assets/js/plugins/metisMenu/jquery.metisMenu.js'
import './assets/js/plugins/pace/pace.min.js'
import './assets/js/plugins/slimscroll/jquery.slimscroll.min.js'
import './assets/js/plugins/switchery/switchery.js'
import './assets/js/inspinia.js'
import './assets/css/animate.css'
import './assets/css/switchery.css'
import './assets/css/flags.css'
import VueToastr2 from 'vue-toastr-2'
import 'vue-toastr-2/dist/vue-toastr-2.min.css'
import VueInlineTextEditor from 'vue-inline-text-editor'
import VueExcel from 'vue-excel-editor'
import VTooltip from 'v-tooltip'
import store from './store'
import Filters from './Filters'
import EditText from './components/Helpers/Form/EditText'
import { createPinia, PiniaVuePlugin } from 'pinia'
// import VueSocketIOExt from 'vue-socket.io-extended'
// import { io } from 'socket.io-client'

export const eventBus = new Vue()

window.toastr = require('toastr')
Vue.component('in-wrapper', InWrapper)
Vue.component('in-ibox', InIbox)
Vue.component('aDataTable', aDataTable)
Vue.use(VTooltip)
Vue.use(papaparse)
Vue.use(Vuex)
Vue.use(VueAxios, axios)
Vue.use(VueAuthenticate, {
  baseUrl: process.env.API,
  loginUrl: '/auth'
})
// Vue.use(auth)
Vue.use(PiniaVuePlugin)
Vue.use(VueBreadcrumbs)
Vue.use(require('vue-shortkey'))
Vue.use(Vddl)
Vue.use(PrettyCheckbox)
Vue.use(VueSweetalert2)
Vue.use(FlagIcon)
Vue.use(VueExcel)
Vue.use(require('vue-moment'))

Vue.component('v-select', {
  extends: vSelect,
  methods: {
    maybeAdjustScroll: () => false
  }
})
Vue.component('a-modal', AphexModal)
Vue.component('a-on-off', OnOff)
Vue.component('a-edit-txt', EditText)
Vue.use(VueToastr2)

// const socket = io('http://206.189.111.13:3000')
// Vue.use(VueSocketIOExt, socket, {
//   store,
//   actionPrefix: 'SOCKET'
// })

Vue.config.productionTip = false
axios.defaults.baseURL = process.env.API
axios.defaults.headers.common['Authorization'] = localStorage.getItem('token')

if (localStorage.getItem('token')) {
  // socket.emit('login', localStorage.getItem('token'))
}

// Add a request interceptor
axios.interceptors.request.use(function (config) {
  if (process.env.NODE_ENV === 'development' && config.url.includes('/v2/')) {
    config.url = config.url.replace('/v2/', '/')
  }
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

axios.interceptors.response.use(response => {
  return response
}, error => {
  if (error.response.status === 401 && window.location.pathname !== '/login') {
    localStorage.setItem('redirect', window.location.href)
    localStorage.removeItem('token')
    window.location = '/'
  }
  return Promise.reject(error)
})

router.beforeEach((to, from, next) => {
  if (to.meta.auth) {
    if (to.meta.auth !== store.getters.isAuthenticated) {
      next('/login')
    }
  }
  next()
})
/* eslint-disable no-new */
Vue.filter('json', value => { return JSON.stringify(value, null, 2) })
Vue.mixin({
  filters: Filters
})

const pinia = createPinia()
Vue.use(pinia)
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App,
    'inline-text-editor': VueInlineTextEditor
  },
  pinia
})



// WEBPACK FOOTER //
// ./src/main.js